import React from 'react';
import ReactDOM from 'react-dom';
// import { createBrowserHistory } from 'history';
import { Provider } from 'react-redux';
import { store, sagaMiddleware } from './Store';
import { Router } from 'react-router-dom';
import rootSaga from './sagas'
import { createRoot } from 'react-dom/client';

import * as serviceWorker from './serviceWorker';
import App from './App';
// import { history } from './history'

sagaMiddleware.run(rootSaga)

store.dispatch({ type: 'APPLICATION_LOADED' })
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
)

// ReactDOM.render(app, document.getElementById('root'));

serviceWorker.unregister();
